<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HIwzKw/tc-custom/9781913618278.jpg?1729082635124" alt="This image is the cover for the book Ancient Egypt, Ancient Wisdom for the New Age"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ancient Egypt, Ancient Wisdom for the New Age
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover how the wisdom of ancient Egypt can provide guidance for living in the modern world with this fascinating, fully illustrated guide.</b><br/>  <br/> Today, there are countless New Age philosophies designed for self-improvement and spiritual development, but none of them match the timeless wisdom contained within the mysteries of Ancient Egypt. This volume introduces readers to the ways of the pharaohs; their relationship to the land and the river Nile; their positive attitudes toward death and the afterlife as set down in <i>The Book of the Dead</i>; and their sacred rites, symbols, and stones which have had a profound influence on cultures throughout history.<br/>  <br/> Fully illustrated with magnificent artwork, this volume also covers Ancient Egyptian history, archeological sites, mysterious relics, and speculation about the meaning and power of the pyramids.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zelda Sharif
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fox Chapel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40af57ea